import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { IMajorTech } from "../../models/MajorTech";
import { Form } from "./Form";
import { Table } from "./Table";
import { EmptyMajorTech } from "./EmptyMajorTech";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IMajorTech
}

export const MajorTech = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyMajorTech, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyMajorTech, open: false })
    };

    return (
        <>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} open={undefined} ></Table>
            { ( permissions.is_Create || permissions.is_Update ) && <Form  permissions={permissions} singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form> }
            <Toast ref={toast} />
        </>
    );
}
